import type { ActivityTimestamp } from '../../types/timeline/activity-timestamp.types';

/**
 * Normalizes a valid date string or Date for timeline activity comparison.
 * @param value - Candidate timestamp; unsupported values and invalid dates are ignored.
 * @returns Epoch milliseconds and a stable token, or null for an invalid candidate.
 */
export const getActivityTimestamp = (
  value: unknown
): ActivityTimestamp | null => {
  if (typeof value === 'string') {
    const timestamp = Date.parse(value);

    if (Number.isNaN(timestamp)) {
      return null;
    }

    return {
      tokenValue: value,
      timestamp,
    };
  }

  if (value instanceof Date) {
    const timestamp = value.getTime();

    if (Number.isNaN(timestamp)) {
      return null;
    }

    return {
      tokenValue: value.toISOString(),
      timestamp,
    };
  }

  return null;
};
